const config = {
	wechat: {
		oauth: function () {
			const website_url = encodeURIComponent(window.location.href);
			return `https://se.blue-dot.com.cn/schneider-truck-minisite-api-dev/platform/wechat/auth?website_url=${website_url}`;
		}
	}
};

export default config;
